import ShowVersionMixin from '@/Core/mixins/ShowVersion';
import { Component, mixins } from 'types-vue'

@Component
export default class AuthPage extends mixins(ShowVersionMixin) {}